<template>
  <div class="study-section">
    <p class="study-section__title">Upload a new Study</p>
    <form action class="study-form">
      <div class="study-form__row">
        <label for="studiesName" class="study-form__label">name</label>
        <fg-input name="studiesName" v-model="name"></fg-input>
      </div>
      <div class="study-form__row">
        <label for="studiesFile" class="study-form__label">csv</label>
        <div class="study-form__file-wrapper">
          <fg-input name="studiesFile" :value="fileName"></fg-input>
          <input
            type="file"
            name="file"
            id="file"
            @change="handleFileChange"
            class="study-form__choose"
          />
          <label for="file" class="study-form__choose-label">Choose file</label>
        </div>
      </div>
      <p-button
        size="sm"
        type="submit"
        style="line-height: 2.4;"
        @click.native="submitStudiesForm"
        >Upload</p-button
      >
    </form>
  </div>
</template>
<script>
import EmptyFieldsError from "../../Notifications/EmptyFieldsError";
import CreateStudy from "../../Notifications/CreateStudy";

export default {
  data() {
    return {
      name: "",
      file: "",
      fileName: ""
    };
  },
  methods: {
    handleFileChange(e) {
      this.file = e.target.files[0];
      this.fileName = e.target.files[0].name;
    },
    submitStudiesForm() {
      if (this.name === "" || this.file === "") {
        this.$notify({
          component: EmptyFieldsError,
          icon: "ti-alert",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger"
        });
        return;
      }
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("file", this.file);

      this.$store.dispatch("postStudy", formData).then(() => {
        this.$notify({
          component: CreateStudy,
          icon: "ti-gift",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success"
        });
        this.name = "";
        this.file = "";
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.study-section {
  &__title {
    border-bottom: 1px solid #dddddd;
    font-size: 20px;
    padding: 5px 0px;
  }
}

.study-form {
  text-align: center;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__label {
    font-size: 16px;
    font-weight: bold;
  }

  &__file-wrapper {
    display: flex;
    width: 211px;
    align-items: center;
  }

  &__choose {
    display: none;
  }

  &__choose-label {
    margin-left: 10px;
    width: 140px;
    margin-bottom: 1rem;
    padding: 9px 3px;
    border-radius: 4px;
    color: white;
    background-color: #66615b;
    cursor: pointer;
  }
}
</style>
